// extracted by mini-css-extract-plugin
export default {"container":"title_container__BFIfn","title":"title_title__kpp6d","subtitle":"title_subtitle__tSrIy"};